import api from './interceptor'
// import wx from 'weixin-js-sdk'
import wx from '../assets/js/weixin-js-sdk-1.6.0'
import store from '@/store'
import { Toast } from 'vant'

export const wxConfig = params => {
  params.nonce = Date.now()
  return api.get('/basis/wxConfigs', { params })
}
export const account = () => {
  let params = { nonce: Date.now() }
  return api.get('/wx/customers/me', { params })
}
export const getWxUserInfo = () => {
  let params = { nonce: Date.now() }
  return api.get('/customer/getWxUserInfo', { params })
}
export const getUsersPrefs = () => {
  let params = { nonce: Date.now() }
  return api.get('/customer/getPrefs', { params })
}
export const getUserByToken = token => {
  return api.get(`/customer/getUserByToken?token=${token}`)
}
export const bindBOUser = token => {
  return api.post(`/customer/bindToken?token=${token}`)
}

export const getWXLocation = () => {
  return new Promise(resolve => {
    wx.ready(() => {
      // wx.checkJsApi({
      //   jsApiList: ['checkJsApi', 'closeWindow', 'chooseImage', 'uploadImage', 'getLocalImgData', 'scanQRCode', 'getLocation'],
      //   success: function(res) {
      //     console.log('=======111======')
      //     console.log(res)
      //     alert('success' + JSON.stringify(res))
      //   }
      // })
      wx.getLocation({
        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          let { latitude, longitude } = res
          let position = {
            lat: latitude,
            lng: longitude
          }
          resolve(position)
          store.commit('SETPOSITION', position)
        }
      })
    })
  })
}
export const chooseImage = max => {
  return new Promise((resolve, rejiect) => {
    wx.ready(() => {
      wx.chooseImage({
        count: max,
        needResult: 1,
        sizeType: ['original', 'compressed'],
        // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'],
        // 可以指定来源是相册还是相机，默认二者都有
        success: function(data) {
          // localIds = data.localIds[0]; // 一定要这样才能获取到本地ID
          // wxuploadImage(localIds);
          resolve(data)
        },
        fail: function(res) {
          console.log(res)
          rejiect(res)
        }
      })
    })
  })
}
export const getLocalImgData = localId => {
  return new Promise((resolve, rejiect) => {
    wx.ready(() => {
      wx.getLocalImgData({
        localId: localId,
        success: async res => {
          let localData = res.localData
          let serverId = await wxUploadImage(localId)
          resolve({
            serverId,
            localData
          })
        },
        fail: res => {
          rejiect(res)
        }
      })
    })
  })
}
export const wxUploadImage = localId => {
  return new Promise((resolve, rejiect) => {
    wx.ready(() => {
      wx.uploadImage({
        localId: localId,
        isShowProgressTips: 0,
        success: res => {
          resolve(res.serverId)
        },
        fail: res => {
          rejiect(res)
        }
      })
    })
  })
}
export const scanCode = () => {
  return new Promise((resolve, rejiect) => {
    wx.ready(() => {
      wx.scanQRCode({
        needResult: 1,
        scanType: ['qrCode', 'barCode'],
        success: function(res) {
          var result = res.resultStr
          resolve(result)
        },
        error: function(res) {
          rejiect(JSON.stringify(res))
          if (res.errMsg.indexOf('function_not_exist') > 0) {
            alert('版本过低请升级')
          }
        }
      })
    })
  })
}

export const wxConfigFn = async () => {
  try {
    let params = {
      url: window.location.href.split('#')[0]
    }
    let wxConfigs = await wxConfig(params)
    wx.config({
      debug: false,
      appId: wxConfigs.appid,
      timestamp: wxConfigs.timestamp,
      nonceStr: wxConfigs.noncestr,
      signature: wxConfigs.signature,
      jsApiList: ['checkJsApi', 'closeWindow', 'chooseImage', 'uploadImage', 'getLocalImgData', 'scanQRCode', 'getLocation']
    })
  } catch (error) {
    wx.error(function(res) {
      console.log('微信配置出错:', res)
      Toast(JSON.stringify('微信配置出错:' + res))
    })
  }
}
